export class ConsumptionModel {
  numPeople: number;
  YearlyElecRequired: number;
}
